var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnsavedChanges(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    clipPath: "url(#clip0_2084_15978)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.1131 8.01189L19.9881 3.88689C19.9239 3.82317 19.8477 3.77276 19.7639 3.73854C19.6802 3.70433 19.5905 3.68699 19.5 3.68751H18.125V9.18751C18.125 9.55218 17.9801 9.90192 17.7223 10.1598C17.4644 10.4176 17.1147 10.5625 16.75 10.5625H11.25C10.8853 10.5625 10.5356 10.4176 10.2777 10.1598C10.0199 9.90192 9.875 9.55218 9.875 9.18751V3.68751H5.75C5.20299 3.68751 4.67839 3.90481 4.29159 4.2916C3.9048 4.6784 3.6875 5.203 3.6875 5.75001V22.25C3.6875 22.797 3.9048 23.3216 4.29159 23.7084C4.67839 24.0952 5.20299 24.3125 5.75 24.3125H7.125V18.125C7.125 17.578 7.3423 17.0534 7.72909 16.6666C8.11589 16.2798 8.64049 16.0625 9.1875 16.0625H18.8125C19.3595 16.0625 19.8841 16.2798 20.2709 16.6666C20.6577 17.0534 20.875 17.578 20.875 18.125V24.3125H22.25C22.797 24.3125 23.3216 24.0952 23.7084 23.7084C24.0952 23.3216 24.3125 22.797 24.3125 22.25V8.50001C24.313 8.40953 24.2957 8.31984 24.2615 8.23608C24.2273 8.15231 24.1768 8.07613 24.1131 8.01189Z",
    fill: "#FD9468"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M11.25 3.6875H16.75V9.1875H11.25V3.6875Z",
    fill: "#FD9468"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M18.8125 17.4375H9.1875C9.00516 17.4375 8.8303 17.5099 8.70136 17.6389C8.57243 17.7678 8.5 17.9427 8.5 18.125V24.3125H19.5V18.125C19.5 17.9427 19.4276 17.7678 19.2986 17.6389C19.1697 17.5099 18.9948 17.4375 18.8125 17.4375Z",
    fill: "#FD9468"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2084_15978)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 26C24.3137 26 27 23.3137 27 20C27 16.6863 24.3137 14 21 14C17.6863 14 15 16.6863 15 20C15 23.3137 17.6863 26 21 26Z",
    fill: "#F79A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0001 21.2C20.7828 21.2 20.5739 21.1159 20.4173 20.9653C20.2606 20.8148 20.1683 20.6095 20.1596 20.3923L20.0487 17.593C20.0443 17.4798 20.0627 17.3669 20.103 17.2611C20.1432 17.1552 20.2044 17.0586 20.2829 16.9769C20.3614 16.8953 20.4555 16.8304 20.5597 16.786C20.6639 16.7416 20.776 16.7188 20.8892 16.7188H21.1109C21.2242 16.7188 21.3362 16.7416 21.4404 16.786C21.5446 16.8304 21.6388 16.8953 21.7173 16.9769C21.7958 17.0586 21.8569 17.1552 21.8972 17.2611C21.9374 17.3669 21.9559 17.4798 21.9514 17.593L21.8405 20.3923C21.8319 20.6095 21.7395 20.8148 21.5829 20.9653C21.4262 21.1159 21.2174 21.2 21.0001 21.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8399 22.4413C21.8399 21.9775 21.464 21.6016 21.0002 21.6016C20.5364 21.6016 20.1604 21.9775 20.1604 22.4413C20.1604 22.9051 20.5364 23.2811 21.0002 23.2811C21.464 23.2811 21.8399 22.9051 21.8399 22.4413Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2084_15978"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(3 3)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2084_15978"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(15 14)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnsavedChanges);
export default __webpack_public_path__ + "static/media/UnsavedChanges.8a871b7c81f9dee0717caa2087c42d68.svg";
export { ForwardRef as ReactComponent };